export enum SortBy {
  Name = "name",
  Date = "date",
  Type = "type",
}

export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}
